module.exports = __webpack_public_path__ + "img/线2.188a1efc.svg";